import { PATH_NAME } from "../configs/pathName";
import { OrderDateGroup } from "../models/IOrderDateGroup";
import axiosInstance from "./axiosInstance";

export const fetchOrderDateGroups = async (): Promise<OrderDateGroup[]> => {
    try {
      const response = await axiosInstance.get(PATH_NAME.API_ORDER_DATE_GROUPS);
      return response.data.result;
    } catch (error) {
      console.error('Error fetching order date groups:', error);
      throw error; // Re-throw to handle in component
    }
  };